<div class="row pb-2 row-height">
  <h1 class="col-12">Terms of Use</h1>
  <div class="contentbox">
    <div class="col-12" [innerHtml]="linkContent | keepHtml"></div>
  </div>
</div>
